/* Exact audited variant matches only. No brand-wide or SKU-based inference. */
if (!customElements.get('fh-size-guide')) {
  customElements.define('fh-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.matches = new Map(this.dataset.variantMap.split(',').map(pair => pair.split(':')));
      this.sizeLabels = JSON.parse(this.querySelector('[data-fh-size-labels]').textContent);
      this.productInfo = this.closest('product-info');
      this.shortcut = this.productInfo?.querySelector(`[data-fh-guide-target="${this.id}"]`);
      this.onShortcutClick = event => {
        if (this.hidden) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        this.focus({preventScroll: true});
        this.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.shortcut?.addEventListener('click', this.onShortcutClick);
      this.showVariant(this.dataset.initialVariant);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) === this.dataset.sectionId) this.showVariant(data.variant?.id);
        });
      }
      this.onVariantInput = event => {
        if (event.target.name === 'id') this.showVariant(event.target.value);
      };
      this.productInfo?.addEventListener('change', this.onVariantInput);
      this.onOptionChange = event => {
        if (event.target.closest('variant-selects')) {
          this.hidden = true;
          if (this.shortcut) this.shortcut.hidden = true;
        }
      };
      this.productInfo?.addEventListener('change', this.onOptionChange);
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.shortcut?.removeEventListener('click', this.onShortcutClick);
      this.productInfo?.removeEventListener('change', this.onVariantInput);
      this.productInfo?.removeEventListener('change', this.onOptionChange);
    }
    showVariant(id) {
      const size = this.matches.get(String(id));
      this.hidden = !size;
      if (this.shortcut) this.shortcut.hidden = !size;
      const label = this.sizeLabels[String(id)];
      this.querySelector('[data-fh-current-size]').textContent = size && label
        ? label + (label === size ? '' : ` (${size} in this chart)`)
        : '';
      this.querySelectorAll('tbody tr').forEach(row => {
        const selected = Boolean(size) && row.dataset.size === size;
        row.classList.toggle('is-selected', selected);
        if (selected) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
        row.querySelector('.fh-size-guide__selected').hidden = !selected;
      });
    }
  });
}
